import BusinessHours from '@/components/BusinessHours/BusinessHours';
import Details from '@/components/Details/Details';
import Tip from '@/components/Tip/Tip';
import IEventType from '@/types/IEventType';
import { Box, Button, FormLabel, Text, Textarea, Tooltip } from '@chakra-ui/react';
import { FcClock } from 'react-icons/fc';
import { ImLab } from 'react-icons/im';
import useSectionSchedule from './SectionSchedule.controller';

export interface ISectionScheduleProps {
	service: IEventType;
	onChange: (values: Partial<IEventType>) => void;
}

export default function SectionSchedule(props: ISectionScheduleProps) {
	const { t, handleGenerateAIScheduleClick, aiForm, isLoading, businessHours } = useSectionSchedule(props);

	return (
		<Details image={<FcClock />} title={t('Schedule')}>
			<Tip>{t('Choose the schedule in which you want to be available to receive bookings.')}</Tip>

			<FormLabel>{t('Enter your schedule')}:</FormLabel>

			<BusinessHours
				isLoading={isLoading}
				businessHours={businessHours.businessHours}
				onAddClick={businessHours.handleAddClick}
				onDeleteClick={businessHours.handleDeleteClick}
				onEndChange={businessHours.handleEndChange}
				onStartChange={businessHours.handleStartChange}
				onTimeZoneChange={businessHours.handleTimeZoneChange}
				onCopyToAllClick={businessHours.handleCopyToAll}
			/>

			<Box my="6">
				<Text fontSize="xs" mb="4" p="4" background="yellow.100" borderRadius="2">
					{t('We are testing a new way of generating schedules using AI. Schedule generation takes up to 60 seconds.')}
				</Text>
				<FormLabel>{t('Enter your schedule using natural language:')}</FormLabel>
				<Textarea
					fontSize="sm"
					placeholder={t('For example: Monday, Tuesday and Friday from 9am to 2pm')}
					id="userInput"
					{...aiForm.register('userInput')}
				></Textarea>
				<Tooltip label={t('This is an experimental feature.')}>
					<Button
						width="100%"
						mt="2"
						type="button"
						onClick={handleGenerateAIScheduleClick}
						isLoading={aiForm.formState.isSubmitting}
						rightIcon={<ImLab />}
					>
						{t('Generate using AI')}
					</Button>
				</Tooltip>
				<Text mt="4" fontSize="xs">
					{aiForm.watch('userInput')}
				</Text>
			</Box>
		</Details>
	);
}
